export default __webpack_public_path__ + "static/media/logoWithoutBanner.ec13e374.png";